import { toast as sonnerToast } from "sonner";
import { reportCaughtError } from "../../lib/sentry/report-caught-error";

export const insufficientReelCreditsEvent = "reelmagic:insufficient-reel-credits";

export function isInsufficientReelCreditsError(error: unknown) {
  return (
    error instanceof Error &&
    /not enough credits for this generation request/iu.test(error.message)
  );
}

export function showReelCreationError(
  error: unknown,
  templateType: "faceless-video" | "reddit-comments" | "text-messages",
) {
  if (isInsufficientReelCreditsError(error)) {
    window.dispatchEvent(new Event(insufficientReelCreditsEvent));
    return;
  }

  reportCaughtError(error, {
    context: { templateType },
    expectedCodes: ["functions/invalid-argument", "functions/unauthenticated"],
    operation: "generation.submit",
  });

  sonnerToast.error(
    error instanceof Error
      ? error.message
      : "Unable to start generation request.",
  );
}
